import { TypesOfSpinner } from 'src/typings/types-of-spinner';
import { IFloorsStateReducer } from './reducer';

type IShareFloorData = Partial<Pick<IFloorsStateReducer,
  | 'selectedHouse'
  | 'selectedSection'
  | 'selectedFloor'
  | 'selectedFloorNumber'
  | 'fromComplex'>>;

const floorNavigationKeys: (keyof IShareFloorData)[] = [
  'selectedHouse',
  'selectedSection',
  'selectedFloor',
  'selectedFloorNumber',
  'fromComplex',
];

const pickFloorNavigationData = (floorData: Partial<IFloorsStateReducer>): IShareFloorData => (
  floorNavigationKeys.reduce((result, key) => {
    if (key in floorData) {
      return {
        ...result,
        [key]: floorData[key],
      };
    }

    return result;
  }, {} as IShareFloorData)
);

export const getShareFloorData = (
  floorData: IFloorsStateReducer,
  displayType: string,
): IShareFloorData | undefined => {
  if (displayType === TypesOfSpinner.viewSpinner) return undefined;

  return pickFloorNavigationData(floorData);
};

export const parseShareFloorData = (
  floorData: string,
  displayType?: string,
): IShareFloorData | undefined => {
  if (displayType === TypesOfSpinner.viewSpinner) return undefined;

  try {
    const parsedFloorData = JSON.parse(floorData);

    if (!parsedFloorData || typeof parsedFloorData !== 'object' || Array.isArray(parsedFloorData)) {
      return undefined;
    }

    return pickFloorNavigationData(parsedFloorData);
  } catch {
    return undefined;
  }
};
